import React, { Component } from "react";
import {
  Wrapper,
  Row,
  Copy,
  Bold,
  Button,
  Gradient
} from "app/NativeComponents/common";

class EngineTab extends Component {
  renderBanner(flag_title) {
    if (!!flag_title) {
      return (
        <Gradient
          color1={this.props.colors.gradient_color_1}
          color2={this.props.colors.gradient_color_2}
          style={{
            backgroundColor: this.props.colors.card_color,
            borderRadius: 15,
            padding: 0,
            paddingRight: 10,
            paddingLeft: 10,
            marginLeft: 5,
            marginRight: 0
          }}
        >
          <Copy
            style={{
              fontSize: 12,
              color: this.props.colors.white_text_color
            }}
          >
            <Bold>{flag_title}</Bold>
          </Copy>
        </Gradient>
      );
    }
  }
  render() {
    if (this.props.active) {
      return (
        <Button
          style={{
            padding: 15,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: this.props.colors.card_color,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20
          }}
          onPress={this.props.onPress}
        >
          <Row>
            <Copy>
              <Bold>{this.props.title}</Bold>
            </Copy>
            {this.renderBanner(this.props.flag_title)}
          </Row>
        </Button>
      );
    }

    return (
      <Button
        style={{
          padding: 15,
          alignItems: "center",
          justifyContent: "center"
        }}
        onPress={this.props.onPress}
      >
        <Row>
          <Copy>{this.props.title}</Copy>
          {this.renderBanner(this.props.flag_title)}
        </Row>
      </Button>
    );
  }
}

export default EngineTab;
